/* eslint-disable vue/prop-name-casing */
<template>
  <LsModal title="Review & Approve" track-id="approve_pending_instant_quote_modal">
    <template #body>
      <div>
        <p class="approve_pending_instant_quote_modal--quote">{{ quoteString }}</p>
        <p class="approve_pending_instant_quote_modal--text">
          Would you like to accept this {{ serviceName }} quote?
        </p>
      </div>
    </template>
    <template #footer>
      <LsButton
        text="Approve Quote"
        track-id="approve_pending_instant_quote_modal-approve"
        test-id="approve"
        :loading="isLoading"
        @click="approveQuote"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsModal, LsButton } from '@/components/common';
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import {
  INSTANT_QUOTE__ACCEPT_PENDING_QUOTE,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
} from '@/store/types';
import VueTypes from 'vue-types';

export default {
  name: 'ApprovePendingInstantQuoteModal',

  components: {
    LsModal,
    LsButton,
  },
  props: {
    quoteString: VueTypes.string.isRequired,
    instantQuoteId: VueTypes.number.isRequired,
    // eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
  },
  computed: {
    ...mapState(['instantQuote']),
    isLoading() {
      return this.instantQuote.loadingStatus.isUpdating;
    },
    serviceName() {
      return _.toLower(this.name);
    },
  },
  methods: {
    ...mapActions([INSTANT_QUOTE__ACCEPT_PENDING_QUOTE, PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    async approveQuote() {
      await this[INSTANT_QUOTE__ACCEPT_PENDING_QUOTE]({
        instantQuoteId: this.instantQuoteId,
        property_id: this.property_id,
        onSuccess: this.onSuccess,
      });
    },
    onSuccess() {
      this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]({ forceRefresh: true });
      this.$parent.close();
      this.$router.push({
        name: 'services',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.approve_pending_instant_quote_modal--quote {
  font-weight: bold;
}
.approve_pending_instant_quote_modal--quote,
.approve_pending_instant_quote_modal--text {
  color: $primary;
}
.themed-app {
  .approve_pending_instant_quote_modal--quote,
  .approve_pending_instant_quote_modal--text {
    color: $theme-color-primary;
  }
}
</style>
